import AuthLayout from "./auth";
export default AuthLayout;
